import pageRegister from './vue-components/pages/auth/registration'
import pageLogin from './vue-components/pages/auth/login.vue'
import pagePasswordRestore from './vue-components/pages/auth/password-restore'
import pagePasswordUpdate from './vue-components/pages/auth/password-update'
import device from './vue-components/pages/device'
import emailVerified from './vue-components/pages/auth/email-verified'
import buildingMain from './vue-components/pages/building/index'
// import buildingAdd  from './vue-components/pages/building/add'
// import deviceAdd  from './vue-components/pages/device/add'

import profilePassoword from './vue-components/pages/profile/security'
import profileAbout from './vue-components/pages/profile/about'
import profileHelp from './vue-components/pages/profile/help'


export default [
    { path: '/', component: pageLogin, meta:{ requireGuest: true }},

    { path: '/login', name: 'login', component: pageLogin, meta: { requireGuest: true } },
    { path: '/register', component: pageRegister, meta: { requireGuest: true } },
    { path: '/register/verified', component: emailVerified, meta: { requireGuest: true } },
    { path: '/password/reset', component: pagePasswordRestore, meta: { requireGuest: true } },
    { path: '/password/reset/:token', component: pagePasswordUpdate, meta: { requireGuest: true } },

    { path: '/building', name: 'building', component: buildingMain, meta: { requireAuth: true } },
    // { path: '/building/add', name: 'building-add', component: buildingAdd, meta: { requireAuth: true } },
    { path: '/building/:buildingId', name: 'building-selected', component: buildingMain, meta: { requireAuth: true } },
    // { path: '/building/:buildingId/add', name: 'device-add', component: deviceAdd, meta: { requireAuth: true } },
    { path: '/building/:buildingId/dev/:devId', name: 'device', component: device, meta: { requireAuth: true } },

    { path: '/profile', redirect: '/profile/password', meta: { requireAuth: true } },
    { path: '/profile/password', component: profilePassoword, meta: { requireAuth: true } },
    { path: '/profile/about', component: profileAbout, meta: { requireAuth: true } },
    { path: '/profile/help', component: profileHelp, meta: { requireAuth: true } },
]

export function redirect(route, loggedIn){
    if(route.meta.requireGuest && loggedIn){
        return { name: 'building' }
    }
    if(route.meta.requireAuth && !loggedIn){
        return { name: 'login' }
    }
    return false;
}
